import React from "react"
import {
  IconButton,
  Grid,
  Card,
  Typography,
  Divider,
  Tooltip,
  Checkbox,
  InputAdornment,
  TextField,
} from "@material-ui/core"
import { PaymentIcon } from "@iconsGallery"
import * as Adm from "@adm"
import * as StyledDOM from "./styles"
import _, { functions, isUndefined, keys } from "lodash"
export const renderPaymentInfo = (props) => {
  const {
    getAccNameLoader = false,
    fetchPaymentAccount = () => "",
    setAnyChanges = () => "",
    classes = {},
    edit = false,
    getPHConfigOpen,
    getPH_GWConfigOpen,
    getPH_ANConfigOpen,
    setPHConfigOpen,
    setPH_GWConfigOpen,
    setPH_ANConfigOpen,
    getPHConfigList,
    setPHConfigList,
    getPH_GWConfigList,
    setPH_GWConfigList,
    getPH_ANConfigList,
    setPH_ANConfigList,
    values = {},
    setFieldValue,
    touched,
    errors,
    handleBlur,
    handleKeyPress,
    setAllowPromptCheck,
    onGlobalUpdate,
    handleDropdownUpdate,
    setAllowPrompt,
    handleChange,
  } = props || {}

  let isClientMode = values?.payment_handler.includes("Client")

  let renderHeader = () => {
    return (
      <Grid item>
        <Typography
          variant="h5"
          style={{
            fontWeight: "700",
            fontSize: "15px",
          }}
        >
          <IconButton className="cls-icon-btn-icon">
            <PaymentIcon />
          </IconButton>
          {window?.globalTranslation("STORE PAYMENT INFORMATION")}
        </Typography>
      </Grid>
    )
  }

  const getCurrencySymbol = JSON.parse(localStorage.getItem("currencyType"))?.currency_symbol


  return (
    <StyledDOM.PaymentMainWrapper>
      {renderHeader()}
      <Grid>
        <Grid
          container
          direction="row"
          style={{ padding: "10px 5px", margin: "0px" }}
          spacing={4}
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Grid item lg={6} md={6} sm={6} xs={12} xl={6}>
            <Grid>
              <Grid item xs={4}>
                <Typography variant="h5" className={classes?.labelHeaderKit}>
                  {`Payment Handler`}
                  <span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              {edit ? (
                <Adm.DropdownFilter
                  style={{ width: "100%" }}
                  list={getPHConfigList}
                  popupOpen={getPHConfigOpen}
                  setPopupOpen={setPHConfigOpen}
                  defaultValue={values?.payment_handler}
                  selectedValue={values?.payment_handler}
                  placeholder={"Select Platform Handler"}
                  name="payment_handler"
                  onChangeEvent={(e, val) => {
                    setFieldValue("paymentAccountName", "")
                    if (val?.name === "Client") {
                      setFieldValue("client_url", "")
                      setFieldValue("payment_provider", "skip")
                      setFieldValue("paymentAccountName", "skip")
                      setFieldValue("pre_auth_amount", 1)
                      setFieldValue("order_expiry_in_days", 1)
                      setFieldValue("refund_window_in_days", 1)
                    } else {
                      setFieldValue("client_url", "https://www.skip.com")
                      setFieldValue("payment_provider", "")
                      if (_.isEmpty(getPH_ANConfigList)) {
                        setFieldValue("paymentAccountName", "")
                      } else {
                        setFieldValue("paymentAccountName", "")
                      }
                    }
                    setFieldValue("payment_handler", val?.name)
                    setAnyChanges(true)
                  }}
                  disableClearable={true}
                  classNameTextField={classes.autoCompleteHeight}
                  touchedControl={touched?.payment_handler}
                  errorControl={errors?.payment_handler}
                />
              ) : (
                <Typography className={classes.textNewLabel}>
                  {values?.payment_handler || "-"}
                </Typography>
              )}
            </Grid>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12} xl={6}>
            {/* isClientMode */}
            {isClientMode ? (
              <Grid>
                <Grid item xs={4}>
                  <Typography variant="h5" className={classes?.labelHeaderKit}>
                    {`Cart Post Endpoint`}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Grid>
                {edit ? (
                  <TextField
                    defaultValue={values.client_url}
                    value={values.client_url}
                    variant="outlined"
                    autoComplete="off"
                    name="client_url"
                    placeholder="Enter Cart Endpoint"
                    className={classes.textField}
                    error={Boolean(touched.client_url && errors.client_url)}
                    helperText={touched.client_url && errors.client_url}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const val = e.target.value
                      setFieldValue("client_url", val)
                      setAnyChanges(true)
                    }}
                    size="small"
                  />
                ) : (
                  <Typography className={classes.textNewLabel}>
                    {values?.client_url || "-"}
                  </Typography>
                )}
              </Grid>
            ) : (
              <Grid>
                <Grid item xs={4}>
                  <Typography variant="h5" className={classes?.labelHeaderKit}>
                    {`Payment Gateway`}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Grid>
                {edit ? (
                  <Adm.DropdownFilter
                    style={{ width: "100%" }}
                    list={getPH_GWConfigList}
                    popupOpen={getPH_GWConfigOpen}
                    setPopupOpen={setPH_GWConfigOpen}
                    defaultValue={values?.payment_provider}
                    selectedValue={values?.payment_provider}
                    placeholder={"Select Platform Handler"}
                    onChangeEvent={(e, val) => {
                      fetchPaymentAccount({
                        getPaymentGateway: val?.name,
                        setFieldValue,
                      })
                      setFieldValue("payment_provider", val?.name)
                      setFieldValue("paymentAccountName", "")
                      setAnyChanges(true)
                    }}
                    disableClearable={true}
                    classNameTextField={classes.autoCompleteHeight}
                    touchedControl={touched?.payment_provider}
                    errorControl={errors?.payment_provider}
                  />
                ) : (
                  <Typography className={classes.textNewLabel}>
                    {values?.payment_provider || "-"}
                  </Typography>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
        {isClientMode === false && (
          <>
            {_.isEmpty(values?.payment_provider) === false && (
              <>
                <Grid
                  container
                  direction="row"
                  style={{ padding: "10px 5px", margin: "0px" }}
                  spacing={4}
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                >
                  <Grid item lg={6} md={6} sm={6} xs={12} xl={6}>
                    <Grid>
                      <Grid item xs={4}>
                        <Typography
                          variant="h5"
                          className={classes?.labelHeaderKit}
                        >
                          {`Account Name`}
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                      </Grid>
                      {edit ? (
                        <>
                          {getAccNameLoader ? (
                            <Typography className={classes.textNewLabel}>
                              {"Fetching Account Names..."}
                            </Typography>
                          ) : (
                            <>
                              <Adm.DropdownFilter
                                style={{ width: "100%" }}
                                list={getPH_ANConfigList}
                                popupOpen={getPH_ANConfigOpen}
                                setPopupOpen={setPH_ANConfigOpen}
                                placeholder={"Select Account name"}
                                defaultValue={""}
                                selectedValue={values?.paymentAccountName}
                                onChangeEvent={(e, val) => {
                                  setFieldValue("paymentAccountName", val?.name)
                                  setFieldValue("paymentMode", val?.mode)
                                  setAnyChanges(true)
                                }}
                                disableClearable={true}
                                classNameTextField={classes.autoCompleteHeight}
                                touchedControl={touched?.paymentAccountName}
                                errorControl={errors?.paymentAccountName}
                              />
                              {_.isEmpty(getPH_ANConfigList) ? (
                                <div
                                  style={{
                                    marginTop: 8,
                                    color: "red",
                                    background: "#ffebef",
                                    padding: 5,
                                    border: "1px solid red",
                                    borderRadius: 4,
                                  }}
                                >{`No account is available, create one or select Client in the Payment Handler to proceed`}</div>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <Typography className={classes.textNewLabel}>
                          {values?.paymentAccountName || "-"}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  {_.isEmpty(values?.paymentAccountName) === false && (
                    <>
                      {values?.payment_provider === "CashFree" ? (
                        <></>
                      ) : (
                        <Grid item lg={6} md={6} sm={6} xs={12} xl={6}>
                          <Grid>
                            <Grid item xs={4}>
                              <Typography
                                variant="h5"
                                className={classes?.labelHeaderKit}
                              >
                                  {`Pre-Auth Amount`}
                                <span style={{ color: "red" }}>*</span>
                              </Typography>
                            </Grid>

                            {edit ? (
                                <TextField
                                  type="number"
                                  defaultValue={values.pre_auth_amount}
                                  value={values.pre_auth_amount}
                                  variant="outlined"
                                  name="pre_auth_amount"
                                  placeholder="Enter Pre-Auth Amount"
                                  className={[
                                    classes.textFieldPre,
                                    classes.textFieldLeft45,
                                  ]}
                                  error={Boolean(
                                    touched.pre_auth_amount &&
                                    errors.pre_auth_amount
                                  )}
                                  helperText={
                                    touched.pre_auth_amount &&
                                    errors.pre_auth_amount
                                  }
                                  onBlur={handleBlur}
                                  onChange={(e) => {
                                    const val = e.target.value
                                    if (val !== "" && Number(val) < 0) {
                                      return
                                    }

                                    setFieldValue("pre_auth_amount", val)
                                    setAnyChanges(true)
                                  }}
                                  onKeyDown={(e) => {
                                    // Prevent negative sign and scientific notation
                                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                                      e.preventDefault()
                                    }
                                  }}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment
                                        position="start"
                                        className={[
                                          classes.adornmentBackground,
                                          classes.adornmentStart,
                                        ]}
                                      >
                                        {getCurrencySymbol}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                            ) : (
                              <Typography className={classes.textNewLabel}>
                                {values?.pre_auth_amount || "-"}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
                {_.isEmpty(values?.paymentAccountName) === false && (
                  <Grid
                    container
                    direction="row"
                    style={{ padding: "10px 5px", margin: "0px" }}
                    spacing={4}
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                  >
                    <Grid item lg={6} md={6} sm={6} xs={12} xl={6}>
                      <Grid>
                        <Grid item xs={4}>
                          <Typography
                            variant="h5"
                            className={classes?.labelHeaderKit}
                          >
                            {`Transaction Window`}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Typography
                            variant="p"
                            className={classes?.sliderHeading}
                          >{`Configurable validity (in days) for transactions`}</Typography>
                        </Grid>

                        {edit ? (
                          <Adm.RangeSlider
                            style={{
                              padding: 0,
                              minWidth: 100,
                              width: "calc(100% - 30px)",
                              marginTop: 50,
                              marginLeft: 10,
                            }}
                            defaultMinValue={1}
                            defaultMaxValue={99}
                            defaultSuffixTextMove="days"
                            defaultValue={values?.order_expiry_in_days}
                            onUpdate={(newValue) => {
                              setAnyChanges(true)
                              if (
                                values.order_expiry_in_days !== newValue?.value
                              ) {
                                setFieldValue(
                                  "order_expiry_in_days",
                                  newValue?.value
                                )
                              }
                            }}
                          />
                        ) : (
                          <Typography className={classes.textWindow}>
                            {values?.order_expiry_in_days || "0"}
                            {" days"}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12} xl={6}>
                      <Grid>
                        <Grid item xs={4}>
                          <Typography
                            variant="h5"
                            className={classes?.labelHeaderKit}
                          >
                            {`Refund Window`}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Typography
                            variant="p"
                            className={classes?.sliderHeading}
                          >{`Configurable validity (in days) for refunds`}</Typography>
                        </Grid>
                        {edit ? (
                          <Adm.RangeSlider
                            style={{
                              padding: 0,
                              minWidth: 100,
                              width: "calc(100% - 30px)",
                              marginTop: 50,
                              marginLeft: 10,
                            }}
                            defaultMinValue={1}
                            defaultMaxValue={values?.order_expiry_in_days || 99}
                            defaultSuffixTextMove="days"
                            defaultValue={values?.refund_window_in_days}
                            onUpdate={(newValue) => {
                              if (
                                values.refund_window_in_days !== newValue?.value
                              ) {
                                setFieldValue(
                                  "refund_window_in_days",
                                  newValue?.value
                                )
                              }
                              setAnyChanges(true)
                            }}
                          />
                        ) : (
                          <Typography className={classes.textWindow}>
                            {values?.refund_window_in_days || "0"}
                            {" days"}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </>
        )}
      </Grid>
    </StyledDOM.PaymentMainWrapper>
  )
}
